import { create } from 'zustand'
import {MapStore} from "../types/map";
import {MapCenter} from "../components/features/Map/MapHelper";

const useMapStore = create<MapStore>((set) => ({
  viewState: {
    height: 400,
    width: 400,
    latitude: 31,
    longitude: 0,
    zoom: 1.5,
    transitionDuration: 1000,
    pitch: 0,
    bearing: 0,
  },
  setViewState: (viewState) => set({ viewState }),

  mapBoundsZoom: { bounds: [0, 0, 0, 0], zoom: 1 },
  setMapBoundsZoom: (mapBoundsZoom) => set({ mapBoundsZoom }),

  updatedBounds: true,
  setUpdatedBounds: (updatedBounds) => set({ updatedBounds }),

  dragPan: true,
  setDragPan: (dragPan) => set({ dragPan }),

  coordsMoved: false,
  setCoordsMoved: (coordsMoved) => set({ coordsMoved }),

  mapCenter: MapCenter,
  setMapCenter: (mapCenter) => set({ mapCenter }),
}));

export default useMapStore;
